const MONTH_YEAR_REGEX = /^(0[1-9]|1[0-2])\/\d{2}$/;

export const MONTH_YEAR_REGEX_MASK = MONTH_YEAR_REGEX.toString().replace(/^\//, "").replace(/\/$/, "");

export function validateMonthYear(value: string) {
    if (!value) {
        return false;
    }

    return MONTH_YEAR_REGEX.test(value);
}
